import { Box, Stack, Typography } from '@mui/material';
import { StakeholderGroup } from 'lib/api/collectionNotifications/types';
import { ManualCollectionNotification } from 'lib/api/collectionNotifications/types';
import React from 'react';

type Status = ManualCollectionNotification['status'];

export const STATUS_ORDER: Status[] = ['Vencida', 'Pendiente', 'Completada'];

export const STATUS_STYLES: Record<
  Status,
  { bgColor: string; textColor: string }
> = {
  Vencida: {
    bgColor: 'rgba(244, 67, 54, 0.06)',
    textColor: '#f44336',
  },
  Pendiente: {
    bgColor: 'rgba(255, 193, 7, 0.12)',
    textColor: '#ff9800',
  },
  Completada: {
    bgColor: 'rgba(76, 175, 80, 0.10)',
    textColor: '#2e7d32',
  },
};

export const StatusPills = ({
  statusCount,
}: {
  statusCount: StakeholderGroup['statusCount'];
}) => (
  <Stack direction="row" spacing={1}>
    {STATUS_ORDER.map((status) => {
      const count = statusCount?.[status];
      if (!count) return null;

      const styles = STATUS_STYLES[status];

      return (
        <Box
          key={status}
          sx={{
            minWidth: 28,
            px: 1.2,
            py: 0.5,
            borderRadius: '999px',
            bgcolor: styles.bgColor,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <Typography
            variant="body2"
            sx={{
              fontWeight: 600,
              color: styles.textColor,
              fontSize: 12,
              lineHeight: 1,
            }}
          >
            {count}
          </Typography>
        </Box>
      );
    })}
  </Stack>
);
